import React, { useContext, useRef, useEffect } from 'react';
import { string } from 'prop-types';
import { cx } from '@emotion/css';
import { IconSvg } from '@ajaibid/components';

import useStockTicker from '@context/stockTickerTab/useStockTickerTab';
import { CoachmarkContext } from '@context/coachmark';

import {
  styNavigation,
  styShadowWrapper,
  styStockTicker,
  styStockTickerWrapper,
  styWrapper,
} from './style';
import useWrapperShadow from './hooks/useWrapperShadow';
import Tab from './components/Tab';

const StockTickerTabs = ({ className }) => {
  const { items } = useStockTicker();
  const { ref, right, left } = useWrapperShadow();

  const scroll = (scrollAmount) => {
    if (!ref.current) {
      return;
    }

    const maxScroll = ref.current.scrollWidth - ref.current.clientWidth;
    const newScrollLeft = ref.current.scrollLeft + scrollAmount;

    if (newScrollLeft > maxScroll) {
      ref.current.scrollTo({ left: maxScroll, behavior: 'smooth' });
      return;
    }

    if (newScrollLeft < 0) {
      ref.current.scrollTo({ left: 0, behavior: 'smooth' });
    }

    ref.current.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
  };

  const { setCoachmarkRefs } = useContext(CoachmarkContext);

  const tickerTabsRef = useRef(null);

  useEffect(() => {
    if (!tickerTabsRef.current) {
      return;
    }
    setTimeout(() => {
      setCoachmarkRefs({ coachmarkStock: { tickerTabs: tickerTabsRef } });
    }, 200);
  }, [tickerTabsRef]);

  return (
    <div ref={tickerTabsRef} className={styWrapper}>
      <div className={cx(className, styShadowWrapper({ leftShadow: left, rightShadow: right }))}>
        <div ref={ref} className={styStockTickerWrapper}>
          <div className={styStockTicker}>
            {items.map((item) => (
              <Tab key={item.code} item={item} />
            ))}
          </div>
        </div>
      </div>
      <div className={styNavigation}>
        <button type="button" onClick={() => scroll(-50)}>
          <IconSvg.Chevron.Left />
        </button>
        <button type="button" onClick={() => scroll(50)}>
          <IconSvg.Chevron.Right />
        </button>
      </div>
    </div>
  );
};

StockTickerTabs.propTypes = {
  className: string,
};

StockTickerTabs.defaultProps = {
  className: '',
};

export default StockTickerTabs;
